export default __webpack_public_path__ + "static/media/app-pic-3.948c4a71.png";